/**
 * Trending Topics in Quantum Computing
 * 
 * The trending topics will appear before a user starts typing in the command palette.
 * All topics appear in the order they are listed here.
 */
export const TRENDING_TOPICS = [
  {
    title: "Quantum Gradients",
    link: "/topics/quantum-gradients"
  },
  {
    title: "Hamiltonian Simulation",
    link: "/topics/hamiltonian-simulation"
  },
  {
    title: "Fault-Tolerant Quantum Computing", 
    link: "/topics/fault-tolerant-quantum-computing"
  },
  {
    title: "Quantum Compilation",
    link: "/compilation"
  },
  {
    title: "Quantum Machine Learning",
    link: "/search?contentType=DEMO&categories=quantum+machine+learning"
  },
];
